<template>
    <bottom-sheet v-model="shows" title="문자발송" fullscreen persistent width="1224" maxWidth="100%" needsLogin v-bind="{ userType }">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents">
            <texting-form v-bind="{ applications, meeting, recruitment, initialForm }" @posted="updateItem" />
            <texting-list showsAddressees v-bind="{ textings }" class="mt-40 mt-lg-60" />
            <v-pagination v-model="page" :length="pageCount" :total-visible="11" color="primary" />
        </v-layout>
    </bottom-sheet>
</template>

<script>
import { initMeeting, initRecruitment, initTexting, initTextingAddressee, USER_TYPES } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import TextingForm from "./texting-form.vue";
import TextingList from "./texting-list.vue";
import api from "@/api";

const userType = USER_TYPES.COMPANY.value;

export default {
    components: {
        BottomSheet,
        TextingForm,
        TextingList,
    },
    props: {
        value: { type: Array, default: () => [] }, // selected applications
        meeting: { type: Object, default: initMeeting },
        paramsProps: { type: Object, default: () => ({}) },
        // recruitment: { type: Object, default: initRecruitment },
        recruitment: { type: Object, default: null },
        applications: { type: Array, default: () => [] },
    },
    data: () => ({
        textings: [],

        page: 1,
        limit: 10,
        query: {},
        summary: { totalCount: 0 },

        userType,

        shows: false,
        loading: false,
    }),
    computed: {
        initialForm() {
            return initTexting({
                _meeting: this.meeting?._id || null,
                _recruitment: this.recruitment?._id || null,
                addressees: this.value.map((item) => initTextingAddressee(item)),
            });
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.query;
            return { ...this.paramsProps, ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
        page() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, textings } = await api.v1.company.textings.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.textings = textings;
            } finally {
                this.loading = false;
            }
        },
        updateItem(item) {
            const index = this.textings.findIndex((texting) => texting?._id == item?._id);
            if (0 <= index) this.textings.splice(index, 1, item);
            else this.textings = [item, ...this.textings];
        },
    },
};
</script>
